import { Literal, Static, Union } from "runtypes";

export const OrderVerificationStatus = Union(
  Literal("SENT"),
  Literal("CONFIRMED"),
  Literal("FAILED"),
);

export type OrderVerificationStatus = Static<typeof OrderVerificationStatus>
